import LandingPage from '@/modules/landingPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/landing-page')({
  component: LandingPage,
})
